module.exports = __webpack_public_path__ + "img/title_uk.77c90489.svg";